import { render, staticRenderFns } from "./chatbot-avatar.vue?vue&type=template&id=2741ee28"
import script from "./chatbot-avatar.vue?vue&type=script&lang=js"
export * from "./chatbot-avatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports